module.exports = __webpack_public_path__ + "img/tongji.361cdc1d.png";